export const environment = {
	production: true,
	environmentName: 'development',
	showLogs: true,
	TOKEN_URL: 'e35d51b9c6e9fd076963d5bf7b980cbd4db8721fbbe3791cf8649ee5d111d2a0',
	api: 'https://api-appcrypto-qa.towerbank.com',
	configToken: 'MmI3ZTE1MTYyOGFlZDJhNmFiZjcxNTg4MDljZjRmMmM=',
	hotjar: { hjid: 5302844, hjsv: 6 },
	sentry: {
		enabled: true,
		dsn: 'https://3c950315c362896dfe4ce7780c0c47fe@o4510539551145984.ingest.us.sentry.io/4510545408425984',
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		sendDefaultPii: true, // GDPR: Permitido en development para debugging
		enableSessionReplay: true // GDPR: Permitido en development para debugging
	},
	grafanaRum: {
		url: 'https://faro-collector-prod-us-east-2.grafana.net/collect/a75ffd1b7273ee528a7ac5ce85959a1b',
		app: {
			name: 'onb-ikigii',
			version: '1.0.0',
			environment: 'development'
		}
	}
};
console.log(environment.environmentName);